import classnames from 'classnames'
import { detect } from 'detect-browser'
import { useEffect, useState, memo } from 'react'
import { Helmet } from 'react-helmet'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import '../../styles/reset.css'
import { isValidUuid } from '../../utils/utils'
import { APP_ENV } from '../../utils/Constants'
import { ws } from '../../events/ws'
import Content from '../content/Content'
import { useStateValue } from '../state-provider/StateProvider'
import {
  setBrand,
  setIsLoading,
  setItems,
  setParentCard,
  setCurrentCard,
  setSpId,
  setTitleStyle,
  setTotalInteractions,
  setWidgetEmbedded,
  setWidgetLocation,
  setSpHash,
  setSequenceStatistics,
  setLiveStream,
  setWidgetLocationReferer,
  setTranslations,
  setLiveChat,
  setGridAreaContent,
  navigateCard,
  setExperienceRootCard,
  setShareBoostEnabled,
  setPartnership,
  setPromotionalDiscountCodes,
} from './App.action'
import {setOrganizationId} from '../chat/Chat.action'
import './App.css'
import {sendToWidget} from "../../utils/postMessages";
import {OrganizationTranslations} from "../../constants/actions";
import {CardData, SequencePollDataViewModel} from "../../api/types";
import {log} from "../../utils/log";
import {useOrientation} from "../../hooks/useOrientation";
import useIsMobile from "../../hooks/useIsMobile";


const AppComponent: React.FC<{}> = ({ }) => {

  const [
    {
      api_url,
      parentCardId,
      sequencePollHash,
      isWidgetMaximized,
      isWidgetEmbedded,
      videoPlayerSourceOrientation,
      videoPlayerControlsVisible,
      header,
      items,
      widgetLocation,
      widgetLocationReferer,
      isSessionEstablished,
      translations,
      surf,
      surfMode,
      organizationId,
      sessionData,
      liveStreamSubscribed,
    },
    dispatch,
  ] = useStateValue()
  const isMobile = useIsMobile()
  const [preloadedCards, setPreloadedCards] = useState<any[]>([])
  const [isContesterBrandingDisplayed, setLogoVisibility] = useState(false)
  const [fonts, setFonts] = useState<{ name: string; url: string }[]>([])
  const [isInitial, setIsInitial] = useState(true)


  let { uuidParam, cardUuidParam } = useParams<{
    uuidParam: string
    cardUuidParam: string
  }>()

  let history = useHistory()
  const location = useLocation()

  let search = new URLSearchParams(location.search)
  if (search.get('experienceId')) {
    //
  }
  if (!uuidParam && search.get('experienceId')) {
    uuidParam = search.get('experienceId')!!
  }
  if (!cardUuidParam && search.get('cardId')) {
    cardUuidParam = search.get('cardId')!!
  }

  function goBack() {
    dispatch(setIsLoading({ isLoading: false }))
    // @ts-ignore
    dispatch(navigateCard(parentCardId, history, "User"))

  }

  let handleBeforeunload = () => {
    ws.close()
  }

  useEffect(() => {
    window.addEventListener('beforeunload', handleBeforeunload)
    return () => window.removeEventListener('beforeunload', handleBeforeunload)
  }, [])

  useEffect(() => {
    if (dispatch && organizationId && sessionData && Object.keys(translations).length == 0) {
      // fetch(api_url + '/i18n/organization/' + organizationId + `?language=${sessionData.languageCode}`)
      fetch(api_url + `/i18n/translations?language=${sessionData.languageCode}`)
        .then<OrganizationTranslations>(res => res.json())
        .then(res => {
          dispatch(setTranslations({ translations: res.translations }))
          sendToWidget({ type: 'translations', value: res.translations })
        })

    }
  }, [dispatch, translations, organizationId, sessionData]);

  useEffect(() => {
    if (surf && surfMode) {
      sendToWidget({ type: 'surf', value: { surf: surf, mode: surfMode} })
    }
  }, [dispatch, surf, surfMode]);

  useEffect(() => {
    // This effect opens Safari instead of the Linkedin Browser in iOS devices.
    const browser = detect()
    let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
    let isChromeiOs = browser?.name === 'crios'
    let isIOS = browser?.os === 'iOS'

    if (browser?.name === 'ios-webview') {
      // window.location = 'safari-https://' + window.location.hostname + window.location.pathname;
      window.location.href =
        'googlechrome://' + window.location.hostname + window.location.pathname
    }
  }, [])

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (sequencePollHash === undefined) {
        dispatch(setSpHash({ hash: 'BACKEND_UNAVAILABLE', postToWidget: true }))
      }
      if (widgetLocation === null) {
        dispatch(setWidgetLocation({ location: window.location.href }))
      }
      if (widgetLocationReferer === null) {
        dispatch(setWidgetLocationReferer({ location: document.referrer ?? window.location.href }))
      }
    }, 1000)

    return () => clearTimeout(timeout)
  }, [sequencePollHash, widgetLocation, widgetLocationReferer])

  useEffect(() => {
    if (isValidUuid(uuidParam)) {
      dispatch(setSpId({ uuid: uuidParam }))
      if (widgetLocation !== null && widgetLocationReferer !== null) {
        ws.init(uuidParam, dispatch, history, widgetLocation, widgetLocationReferer, isWidgetEmbedded)
      }
    } else {
      if (APP_ENV === 'development') {
        // dev code
      } else {
        // production code
        window.location.replace('https://contester.net')
        return
      }
    }

    if (!isSessionEstablished) {
      return // this is important, otherwise some further API calls which expect established session won't work
    }

    if (sequencePollHash === 'default') {
      return
    }

    if (widgetLocation === undefined) {
      return
    }

    let fetchUrl = api_url + '/sequencepolls/' + uuidParam

    // here we instantiate new image with onload callbacks to know when all images are cached.
    function mapItemImages(items: CardData[]): any[] {

      return items.map((i: CardData) => {
        let img = new Image()
        img.src = i.mediaLink!!
        return {
          ...i,
          image: img,
          title: i.title,
          header: i.header,
        }
      })
    }

    if (isWidgetEmbedded) {
      fetchUrl = appendQueryParameter(fetchUrl, 'widget=true')
    }
    fetchUrl = appendQueryParameter(fetchUrl, 'h=' + sequencePollHash)

    if (location.search.length > 1) {
      // it is important to append only contester_ query params. Otherwise browser and cloudflare caches won't do much for us
      location.search
        .substring(1)
        .split('&')
        .forEach(param => {
          if (param.startsWith('contester')) {
            fetchUrl = appendQueryParameter(fetchUrl, param)
          }
        })
    }

    fetch(fetchUrl)
      .then<SequencePollDataViewModel>(res => res.json())
      .then(async result => {
        dispatch(setIsLoading(true))

        let experience = result.experience

        dispatch(setShareBoostEnabled(experience.shareBoost))

        dispatch(setExperienceRootCard(result.card))

        dispatch(setPromotionalDiscountCodes(experience.promotional.discountCodes))


        if (experience.brandFeatureList) {
          sendToWidget({ type: 'brand-feature-list', value: { brandFeatureList: experience.brandFeatureList } })
        }

        sendToWidget({ type: 'experience-escape-urls', value: { escapeUrls: experience.escapeUrls } })
        sendToWidget({ type: 'experience-allow-subdomain-surfing', value: { allowSubdomainSurfing: experience.allowSubdomainSurfing }})

        if (experience.displayOptions.availableDisplayTypes) {
          sendToWidget({
            type: 'available-display-types',
            value: {
              availableDisplayTypes: experience.displayOptions.availableDisplayTypes,
            }
          })
        }

        let card = navigateCardHierarchy(result.card, cardUuidParam, setPreloadedCards) ?? result.card // it is possible that cardUuidParam is no longer within SP tree

        dispatch(setOrganizationId({ organizationId: experience.organizationId }))

        const styles = JSON.parse(
          card.cardStyleParameters.headingTitleStyle || '{}',
        )
        dispatch(setTitleStyle({ titleStyle: styles }))
        dispatch(setParentCard({ parentCardId: card.parentCardId }))
        dispatch(setSequenceStatistics({ statistics: card.statistics }))
        dispatch(setLiveStream({ liveStream: card.liveStream || null }))
        dispatch(setLiveChat({ liveChat: card.liveChat }))

        if (isInitial &&
          (!liveStreamSubscribed || (card.liveStream?.id && !liveStreamSubscribed)) &&
          (card.liveStream?.notificationSettings?.expandedByDefault == true)
          //@ts-ignore
          && (card.liveStream?.scheduledAt && new Date() < new Date(card.liveStream.scheduledAt * 1000))
        ) {
          setTimeout(() => {
            dispatch(setGridAreaContent('LiveStreamReminderForm'))
          }, 3000)
        }
        /**
         * Override videoUrl with optimized variants
         */
        let desktopOptimizedVideoUrl = card.header.videoUrlsByDeviceType?.["Desktop"]// ?? "https://media.contester.net/data/46293b2e-7790-474e-8f68-2af924e412a9/ca3a54e1-8d32-4d7e-b8c0-ef6b29532f19-Desktop.mp4"
        let desktopOptimizedVideoFormat = card.header.videoFormatsByDeviceType?.["Desktop"]// ?? [1, 2]
        let desktopOptimizedVideoPoster = card.header.videoPostersByDeviceType?.["Desktop"]
        if (desktopOptimizedVideoFormat && desktopOptimizedVideoUrl && desktopOptimizedVideoFormat[0] < desktopOptimizedVideoFormat[1]) {
          // vertical video, force Desktop resolution
          card.header.videoUrl = desktopOptimizedVideoUrl
          if (desktopOptimizedVideoPoster) {
            card.header.videoPoster = desktopOptimizedVideoPoster
          }
        } else {
          if (isMobile) {
            let mobileOptimizedVideoUrl = card.header.videoUrlsByDeviceType["Mobile"]
            if (mobileOptimizedVideoUrl) {
              card.header.videoUrl = mobileOptimizedVideoUrl
            }
            let mobileOptimizedVideoPoster = card.header.videoPostersByDeviceType?.["Mobile"]
            if (mobileOptimizedVideoPoster) {
              card.header.videoPoster = mobileOptimizedVideoPoster
            }
          } else {
            if (desktopOptimizedVideoUrl) {
              card.header.videoUrl = desktopOptimizedVideoUrl
            }
            if (desktopOptimizedVideoPoster) {
              card.header.videoPoster = desktopOptimizedVideoPoster
            }
          }
        }

        // card.header.liveStreamUrl = 'https://sample.vodobox.net/skate_phantom_flex_4k/skate_phantom_flex_4k.m3u8'
        // card.header.liveStreamUrl = 'https://bitdash-a.akamaihd.net/content/sintel/hls/playlist.m3u8'

        dispatch(setPartnership({ partnership: experience.partnership }))

        dispatch(setCurrentCard({ cardUuid: card.cardId }))
        setFonts(experience.fonts.fonts.filter(f => f.url))
        setIsInitial(false)


        if (experience.displayOptions.isContesterBrandingDisplayed) {
          setLogoVisibility(true)
        }

        if (card.cardType !== 'DIRECT_LINK') {
          dispatch({
            type: 'SET_HEADER',
            header:
              card.header.title === '' &&
              card.header.videoUrl === null &&
              card.header.imageUrl === null
                ? null
                : card.header,
          })
        }

        if (card.cardType === 'VIDEO_ONLY') {
          dispatch(setItems({ items: mapItemImages(navigateCardHierarchy(result.card, card.parentCardId, setPreloadedCards)!!.items) }))
        } else {
          dispatch(setItems({ items: mapItemImages(card.items) }))
        }

        dispatch(setBrand({ brand: experience.brand }))
        dispatch(
          setTotalInteractions({
            totalInteractions: card.statistics.totalInteractions,
          }),
        )
        dispatch(setIsLoading(false))

        sendToWidget({ type: 'content-loaded', value: {} })
      })
      .catch(e => {
        log(e)
      })

    return () => {
      window.removeEventListener('popstate', goBack)
    }
  }, [
    history,
    uuidParam,
    cardUuidParam,
    sequencePollHash,
    dispatch,
    api_url,
    widgetLocation,
    widgetLocationReferer,
    isSessionEstablished,
  ]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleWidgetMessage = (event: MessageEvent) => {
    if (event?.data?.type === 'widget-location') {
      dispatch(setWidgetLocation({ location: event?.data?.value?.href }))
      dispatch(setWidgetEmbedded({ status: true }))
    }
    if (event?.data?.type === 'widget-location-referer') {
      dispatch(setWidgetLocationReferer({ location: event?.data?.value?.href }))
    }
    if (event?.data?.type === 'widget-surf-page-load') {
      ws.sendPageLoad(event?.data?.value?.url)
    }
    if (event?.data?.type === 'iframe-failed-page-load') {
      ws.sendPageLoadFailed(event?.data?.value?.from)
    }
  }

  useEffect(() => {
    window.addEventListener('message', handleWidgetMessage, true)
    sendToWidget({ type: 'widget-status', value: {} })
    return () => {
      window.removeEventListener('message', handleWidgetMessage, true)
    }
  }, [])

  const appHeight = () => {
    const doc = document.documentElement
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
  }

  useEffect(() => {
    window.addEventListener('resize', appHeight)
    return () => {
      window.removeEventListener('resize', appHeight)
    }
  }, [])

  const orientation = useOrientation()
  const landscapeMode = orientation === "landscape"

  return (
    <>
      <Helmet>
        <meta http-equiv="ScreenOrientation" content="autoRotate:disabled" />
      </Helmet>
      <div className="App">
        <div id="main">
          <div
            id="sequence-poll"
            className={classnames({
              'is-embedded': isWidgetEmbedded,
              'is-maximized': isWidgetMaximized,
              'is-minimized': !isWidgetMaximized,
              'is-media-vertical': videoPlayerSourceOrientation === "Vertical",
              'is-media-horizontal': videoPlayerSourceOrientation === "Horizontal",
              'is-mobile-layout': isMobile,
              'controls-visible': videoPlayerControlsVisible,
              'has-footer-logo': isContesterBrandingDisplayed,
              'no-widget': window.self === window.top,
              'has-heading':
                header?.videoUrl || header?.liveStreamUrl || header?.imageUrl,
              'is-landscape': landscapeMode,
              'is-portrait': !landscapeMode,
              'has-header':
                !(items.length == 0 || header === null) &&
                !header?.imageUrl &&
                !header?.videoUrl &&
                !header?.liveStreamUrl,
            })}
          >
            <Content/>
          </div>
        </div>
        <div id="brandContent"></div>
      </div>
      <div style={{ display: 'none' }}>
        {preloadedCards.map(card => (
          <img key={card.cardId} src={card.mediaLink} />
        ))}
      </div>
      {fonts.map(font => (
        <style key={font.url}>@import url('{font.url}');</style>
      ))}
    </>
  )
}

AppComponent.whyDidYouRender = true

export const App = memo(AppComponent)



export function appendQueryParameter(fetchUrl: string, param: string): string {
  let url = fetchUrl
  if (url.indexOf('?') > -1) {
    url += '&' + param
  } else {
    url += '?' + param
  }

  return url
}

export function navigateCardHierarchy(tree: CardData, cardId: string | undefined, setPreloadedCards: ((p: any[]) => void) | undefined): CardData | undefined {
  let found = undefined

  if (cardId === undefined || tree.cardId === cardId) {
    found = tree
  }
  if (!found) {
    tree.items.forEach(function (item: any) {
      let result = navigateCardHierarchy(item, cardId, setPreloadedCards)
      if (result) {
        found = result
      }
    })
  } else {
    let preload: any[] = []
    found.items.forEach(function (child: any) {
      preload.push(child)
      child.items.forEach(function (grandChild: any) {
        preload.push(grandChild)
      })
    })
    if (setPreloadedCards) {
      setPreloadedCards(preload)
    }
  }

  return found
}